export default __webpack_public_path__ + "static/media/directbox-send.67509609.svg";